import React, {Component} from 'react';
import { connect } from 'react-redux';
import Switch from '@material-ui/core/Switch';
import Row from "react-bootstrap/Row";
import classes from './GameSearchBar.module.css';
import { withStyles } from '@material-ui/core/styles';
import cyan from "@material-ui/core/colors/cyan";
import blue from "@material-ui/core/colors/blue";
import Form from "react-bootstrap/Form";
import GameTypeInput from "../UI/GameTypeInput/GameTypeInput";
import PublisherInput from "../UI/PublisherInput/PublisherInput";
import DeveloperInput from "../UI/DeveloperInput/DeveloperInput";
import ReleaseInput from "../UI/ReleaseInput/ReleaseInput";
import * as actionTypes from "../../store/actions/actionTypes";
import SingleAuthorInput from "../UI/SingleAuthorInput/SingleAuthorInput";
import GameStyleInput from "../UI/GameStyleInput/GameStyleInput";
import ManualSearchBar from "../ManualSearchBar/ManualSearchBar";


// If set to false it will work on every keystroke, if true it will search manually.
// This was created due to server constraints. It also might be a good idea to move it to configs.js
const setManualSearch = true;

class GameSearchBar extends Component {

    state = {
        showOnlyExamples: false,
    };


    CustomSwitch = withStyles({
        switchBase: {
            color: blue[50],
            '&$checked': {
                color: cyan[500],
            },
            '&$checked + $track': {
                backgroundColor: cyan[500],
            },
        },
        checked: {},
        track: {},
    })(Switch);

    updateAuthor = (id) => {
        if (id) {
            this.props.onUpdateAuthor(+id)
        } else {
            this.props.onUpdateAuthor(id)
        }

    }

    render () {
        const gameNameSearch = setManualSearch ?
            <ManualSearchBar currentSearchFilter={this.props.game_name_filter} updateCurrentFilter={this.props.updateGameNameFilter}/>
            : <Form.Control
                type="text"
                placeholder="Enter the game name you want to search for."
                value={this.props.game_name_filter}
                onChange={(event) => {
                    this.props.updateGameNameFilter(event.target.value)
                    this.props.updatePage(0);
                }}/>

        const gameDescriptionSearch = setManualSearch ?
            <ManualSearchBar currentSearchFilter={this.props.game_description_filter} updateCurrentFilter={this.props.updateGameDescriptionFilter}/>
            : <Form.Control
                type="text"
                placeholder="Enter words from a description you want to search for."
                value={this.props.game_description_filter}
                onChange={(event) => {
                    this.props.updateGameDescriptionFilter(event.target.value)
                    this.props.updatePage(0);
                }}
            />

        // console.log('RENDER: ', this.state, this.props);
        return (
            <header className={classes.GameSearchBar}>
                <section>
                    <div className="card">
                        <h4 className={"card-header "+classes.SearchHeader} onClick={this.props.toggleSearch}>{this.props.headerText}:</h4>
                        <div className="card-body">
                            <div className="cardText">
                                <div className={classes.SerchRow} style={{marginBottom: 8}}>
                                    <Row>
                                        <div className='col-sm-6'>
                                            <div className={classes.SearchCount}>
                                                {this.props.gamesCount.toLocaleString() + " games match this search."}
                                            </div>
                                        </div>
                                        <div className='col-sm-6'>
                                            <span style={{
                                                display: 'inline-flex',
                                                width: '100%',
                                                alignItems: 'center',
                                                justifyContent: "right"
                                            }}>
                                                <span style={{whiteSpace: "nowrap"}}>Filter by style: </span>
                                                <GameStyleInput
                                                    currentSelection={this.props.gameStyleFilter}
                                                    onUpdate={this.props.updateGameStyleFilter}
                                                    gameStylesArr={this.props.gameStylesArr}
                                                />
                                            </span>
                                        </div>
                                    </Row>
                                </div>
                                <div className={classes.SerchRow}>
                                    Game Name
                                    {gameNameSearch}
                                </div>
                                <div className={classes.SerchRow}>
                                    Game Description
                                    {gameDescriptionSearch}
                                </div>
                                <div className={classes.SerchRow}>
                                    Game Type
                                    <GameTypeInput
                                        game_types_filter={this.props.game_types_filter}
                                        gameTypesUpdate={this.props.updateGameTypesFilter}
                                        updatePage={this.props.updatePage}
                                        closeGameDetails={this.props.closeGameDetails}
                                        gameTypesArr={this.props.gameTypesArr}
                                    />
                                </div>
                                <div className={classes.SerchRow}>
                                    Publisher
                                    <PublisherInput
                                        game_publishers_filter={this.props.game_publishers_filter}
                                        gamePublishersUpdate={this.props.updateGamePublishersFilter}
                                        updatePage={this.props.updatePage}
                                        closeGameDetails={this.props.closeGameDetails}
                                        publishersArr={this.props.publishersArr}
                                    />
                                </div>
                                <div className={classes.SerchRow}>
                                    Developer
                                    <DeveloperInput
                                        game_developers_filter={this.props.game_developers_filter}
                                        gameDevelopersUpdate={this.props.updateGameDevelopersFilter}
                                        updatePage={this.props.updatePage}
                                        closeGameDetails={this.props.closeGameDetails}
                                        developersArr={this.props.developersArr}
                                    />
                                </div>
                                <div className={classes.SerchRow}>
                                    Submitted By
                                    <SingleAuthorInput
                                        userId={null}
                                        authors_filter={this.props.authors_filter}
                                        authorsUpdate={this.updateAuthor}
                                        updatePage={this.props.updatePage}
                                        closePatternDetails={this.props.closeGameDetails}
                                        usersArr={this.props.usersArr}
                                    />
                                </div>
                                <div className={classes.SerchRow}>
                                    Release Date
                                    <ReleaseInput
                                        release_start_filter={this.props.release_start_filter}
                                        releaseStartUpdate={this.props.updateReleaseStartFilter}
                                        release_end_filter={this.props.release_end_filter}
                                        releaseEndUpdate={this.props.updateReleaseEndFilter}
                                        updatePage={this.props.updatePage}
                                        closeGameDetails={this.props.closeGameDetails}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </header>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onUpdateAuthor: (author_id) => dispatch({type: actionTypes.UPDATE_GAMES_AUTHOR_FILTER, author: author_id})
    }
};

const mapStateToProps = state => {
    return {
        // authors_filter: state.patternLibrary.authors_filter,
        // groups_filter: state.patternLibrary.groups_filter,
        // keywords_filter: state.patternLibrary.keywords_filter,
        game_name_filter: state.gamesReference.game_name_filter,
        game_description_filter: state.gamesReference.game_description_filter,
        game_types_filter: state.gamesReference.game_types_filter,
        game_publishers_filter: state.gamesReference.game_publishers_filter,
        game_developers_filter: state.gamesReference.game_developers_filter,
        authors_filter: state.gamesReference.authors_filter,
        release_start_filter: state.gamesReference.release_start_filter,
        release_end_filter: state.gamesReference.release_end_filter,
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GameSearchBar);